<template lang="html">
   <transition name="slide-fade">
      <div class="ap-delete-modal" v-show="showModal">
         <div class="overlay">
            <div class="row justify-content-end">
               <div class="col-md-6 col-lg-5 col-xl-4">
                  <div class="ap-delete-modal-content" :class="content_class" @keyup.esc="closeModal()" tabindex="0">
                     <div class="clearfix">
                        <div class="close-box" @click="closeModal()">
                           <i class="fa fa-times r"></i> 
                           <div class="l">Close</div>
                        </div>
                     </div>
                     <div class="title-box-modal clearfix">
                        <div class="icon-box l">
                           <i class="fa fa-trash-alt"></i>
                        </div>
                        <div class="txt-box l">
                           <div class="title">Delete</div>
                           <div class="subtitle">Delete a record</div>
                        </div>
                     </div>
                     <div class="scroll-content">
                        <scrollbar>
                           Do you wish to Delete <span v-html="delete_message"></span>?
                           <div class="btns clearfix">
                              <div class="btn l" @click="closeModal()">Cancel</div>
                              <div class="btn btn-danger r" @click="deleteRecord()" :disabled="loading">
                                 Proceed <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                              </div>
                           </div>
                        </scrollbar>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </transition>
</template>

<script>
import VueScrollbar from 'vue-scrollbar-simple';

export default {
   props:{
      show: {
         type: [Boolean, Number],
         default: false
      },
      content_class:{
         type: String,
         default: ''
      },
      delete_message: ''
   },
   components:{
      scrollbar: VueScrollbar
   },
   computed: {
      ...mapGetters([
         'loading',
      ])
   },
   watch: {
      show(){
         this.showModal = this.show
      },
   },
   data () {
      return {
         showModal: this.show,
         isLoading: this.loading
      }
   },
   methods:{
      closeModal(){
         this.$emit('close',true)
      },
      deleteRecord(){
         this.$emit('delete',true)
      },
   }
}
</script>

<style lang="scss">
   .ap-delete-modal{
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 3000;

      .scroll-content{
         height: calc(100vh - 150px);
      }
      .overlay{
         background: rgba($nav-side-color,.4);
         height: 100%;
         width: 100%;

         .row{
            height: 100%;

            div[class*="col"]{
               padding: 0 !important;
            }
         }
         .ap-delete-modal-content{
            padding: 20px;
            height: 100%;
            background: $white;
            border-left: solid 1px hsl(0, 0%, 80%);

            .title-box-modal{
               padding: 15px 20px;
               margin: 20px -20px !important;
               background: #F4F4F4;

               .icon-box{
                  background: rgba($danger,.3);
                  width: 40px;
                  height: 40px;
                  font-size: 24px;
                  padding: 4px 0;
                  margin: -5px 10px 0 0;
                  text-align: center;
                  border-radius: 50%;
                  color: $danger;
               }
               .title{
                  font-size: 15px;
                  font-weight: 600;
                  line-height: 13px;
               }
            }
            .close-box{
               font-weight: 600;
               cursor: pointer;
               float: right;

               .fa{
                  padding: 2px 0 0 15px !important;
                  font-size: 15px;
               }
            }
            .close-box:hover{
               color: $color-two;
            }
         }
      }
   }
</style>